<template>
  <!-- 模板绑定 -->
  <div class="templateBind">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['权限管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="delDettle"
          :disabled="selectedList.length == 0"
          >批量删除</el-button
        >
        <el-button type="primary" @click="open" icon="el-icon-document-add"
          >添加模板绑定</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          placeholder="状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <label class="label">类型：</label>
        <el-select
          placeholder="类型"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.type"
        >
          <el-option
            v-for="(item, index) in txtTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChange"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="index"
        show-overflow-tooltip
        label="序号"
      >
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="img"
        show-overflow-tooltip
        label="图片"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.TemplateImg"
            alt="图片"
            style="height: 50px; width: auto; vertical-align: middle"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="TemplateRelationCode"
        align="center"
        show-overflow-tooltip
        label="模板编号"
      >
      </el-table-column>
      <el-table-column
        prop="TemplateName"
        label="模板"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="activityType"
        label="活动类型"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.TypeCode == '2'"
            >组合商品{{ scope.row.PromotionTitle }}</el-tag
          >
          <el-tag type="success" v-else
            >商品分类{{ scope.row.CategoryTitle }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="Status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.Status == '0'">未上架</el-tag>
          <el-tag type="success" v-if="scope.row.Status == '1'">已上架</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.Status == '0'"
            type="warning"
            style="padding: 2px 3px"
            @click="AuditTem(scope.row.TemplateRelationCode, 1)"
            plain
            >上架</el-button
          >
          <el-button
            v-if="scope.row.Status == '0'"
            type="warning"
            style="padding: 2px 3px"
            @click="Relation_edit(row.TemplateRelationCode)"
            plain
            >模板绑定</el-button
          >
          <el-button
            v-if="scope.row.Status == '1'"
            type="warning"
            style="padding: 2px 3px"
            @click="AuditTem(scope.row.TemplateRelationCode, 0)"
            plain
            >下架</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">模板绑定</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="120px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="选择活动类型" prop="type">
              <el-select
                style="width: 100%"
                @change="change"
                v-model="addForm.type"
                placeholder="请选择活动区域"
              >
                <el-option label="商品组合活动" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="活动模板" prop="activity" v-show="show">
              <el-select
                ref="active"
                style="width: 100%"
                v-model="addForm.activity"
                placeholder="请选择活动区域"
              >
                <el-option
                  v-for="(item, index) in activeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品组合" prop="goodMode" v-show="show">
              <el-select
                style="width: 100%"
                v-model="addForm.goodMode"
                placeholder="请选择活动区域"
              >
                <el-option
                  v-for="(item, index) in goodModeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序值" prop="sort">
              <el-input v-model="addForm.sort" clearable></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="image">
              <img-view :imgList="[{ url: img_url, id: 0 }]"> </img-view>
              <upload
                @fileChange="uploadSuccess"
                accept="image/jpg,image/jpeg,image/png"
              >
              </upload>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="sureModify">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项

export default {
  name: "templateBind",
  data() {
    return {
      /**表格数据 */
      //序号	图片	模板编号	模板	活动类型	标题	状态	排序	操作
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      addDrawer: false,
      show: false,
      searchForm: {
        /**搜索表单 */ status: "0",
        type: "0",
        name: "",
      },
      id: "",
      addForm: {
        type: "",
        config: "", //选择模板
        activity: "", //模板组合
        goodMode: "", //商品组合
        sort: "", //排序
        image: "",
      },
      addFormImg: "",
      formRule: {
        type: [mustFill],
        config: [mustFill], //选择模板
        activity: [mustFill], //模板组合
        goodMode: [mustFill], //商品组合
        sort: [mustFill], //排序
        image: [mustFill],
      },
      statusList: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "0",
          label: "未上架",
        },
        {
          value: "1",
          label: "已上架",
        },
      ],
      type: "",
      img_url: "",
      txtTypeList: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "商品组合",
        },
        {
          value: "2",
          label: "商品分类",
        },
      ],
      /**select选中项 */
      selectedList: [],
      activeList: [],
      goodModeList: [],
    };
  },
  components: {},
  mounted() {
    this.getTableData();
    this.getActityDetail();
    this.gethuoDetail();
  },
  methods: {
    /**获取管理员数据 */
    getTableData() {
      this.$request({
        method: "post",
        url: "Admin/Template/ashx/ReturnJson.ashx",
        data: {
          type: "TemplateRelationLIst",
          status: this.searchForm.status,
          strWhere: this.searchForm.name,
          txtType: this.searchForm.type,
          PageIndex: this.currPage,
          PageSize: this.pageSize,
        },
      }).then((res) => {
        console.log(res);
        if (res.flag === 0) {
          this.tableData = res.data;
        }
      });
    },
    change() {
      if (this.addForm.type == 0) {
        this.show = true;
      }
    },
    open() {
      this.addDrawer = true;
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    sureModify() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this.$requestSys({
            method: "post",
            url:
              "Template/ashx/ReturnJson.ashx?type=SaveTemplateRelation&sltTemplateRelation=" +
              "this.searchForm.type" +
              "&strwhere=" +
              this.searchForm.type +
              "&txtType=" +
              "this.searchForm.status" +
              "&txtSortId=" +
              this.searchForm.sort +
              "&sltcategory=" +
              this.searchForm.activity +
              "&sltprom=" +
              this.searchForm.goodMode +
              "&txtImgUrl=" +
              this.searchForm.image,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          return false;
        }
      });
    },
    clearForm() {
      this.addDrawer = false;
    },
    // 上传图片
    uploadSuccess(file) {
      let formData = new FormData();
      file.forEach((ele, index) => {
        formData.append("file" + index, ele);
      });
      this.$uploadRequest({
        url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=Tem",
        method: "post",
        data: formData,
      })
        .then((res) => {
          this.addForm.image = res.message;
          this.img_url = this.$setImgUrl(res.message);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取活动模板
    getActityDetail() {
      this.$request({
        method: "post",
        url: "Admin/Template/ashx/returnJson.ashx?type=selectTemplate",
        data: {},
      }).then((res) => {
        if (res.flag === "0") {
          this.activeList = this.recursion(res.templatestr);
        }
      });
    },
    recursion(list) {
      list = list.split("</option><option");
      list = list.map((item) => {
        let label = item
          .split("'>")[1]
          .split("</option>")[0]
          .replace(/&nbsp;/g, " ");
        let value = item.split("value='")[1].split("'>")[0];
        return { label, value };
      });
      return list;
    },
    gethuoDetail() {
      this.$request({
        method: "post",
        url: "Admin/Template/ashx/returnJson.ashx?type=selectCategory",
        data: {},
      }).then((res) => {
        if (res.flag === "0") {
          console.log(res);
          this.goodModeList = this.recursion(res.category);
        }
      });
    },
    // 删除列表数据
    delDettle() {
      let s = [];
      this.selectedList.forEach((i) => {
        s.push(i.TemRelationCode);
      });
      s = s.join();
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$requestSys({
            method: "post",
            url:
              "Template/ashx/ReturnJson.ashx?type=TemRelationDel&strWhere=" + s,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    // 上下架
    AuditTem(row, stsatus) {
      this.$confirm("确定操作此条吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          var type = "AuditTemplateRelation";
          this.$requestSys({
            method: "post",
            url:
              "Template/ashx/ReturnJson.ashx?type=" +
              type +
              "&id=" +
              row +
              "&status=" +
              stsatus,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    // 编辑
    Relation_edit() {}, // 编辑
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
  },
};
</script>

<style scoped>
.templateBind {
  width: 100%;
  height: 100%;
}
</style>
